export default __webpack_public_path__ + "static/media/girl_register.13c4d15f.jpg";